import { Box, Drawer, Paper, Toolbar, useTheme } from '@mui/material';
import { Environment } from 'shared/environment';
import { useIsDrawerMenuOpen } from 'shared/store/drawer';
import { SidebarItem } from './SidebarItem';
import {IListItemMenuProps} from 'shared/types/crtlAcess';

import { useTranslation } from 'react-i18next';

interface IMenuSideBarProps{
  itensMenu: IListItemMenuProps[] ;
}

export const MenuSideBar: React.FC<IMenuSideBarProps> = ({ itensMenu }) => {
  const isDrawerMenuOpen = useIsDrawerMenuOpen();
  const theme = useTheme();
  const { t } = useTranslation();
  

  return (
    <Box
      component={Drawer}
      sx={{
        width: Environment.TAMANHO_DO_DRAWER_MENU,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: Environment.TAMANHO_DO_DRAWER_MENU,
          boxSizing: 'border-box',
          zIndex: (theme) => theme.zIndex.drawer + 1
        },
      }}
      variant='persistent'
      anchor='left'
      open={isDrawerMenuOpen}>
      <Toolbar sx={{
        height: theme.spacing(20),
      }} />
      <Box height='100%' display='flex' flexDirection='column' component={Paper} >
        {itensMenu.map((item, index) => <SidebarItem key={index} level={0} title={item.title} icon={item.icon} path={item.path} childrens={item.childrens} />)}
      </Box>
    </Box>
  );
};
